module.exports = __webpack_public_path__ + "static/media/plus-filled.ba58a772.svg";